import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { AppLoader } from '~/components/AppLoader';
import withAuthRequired from '~/components/withAuthRequired';
import { USER_ROLES } from '~/constants';
import { agencyRoutes } from '~/core/router/groups';

const Dashboard = () => {
  const router = useRouter();

  useEffect(() => {
    router.push(agencyRoutes.agencyTalent);
  }, [router]);

  if (status === 'loading') return <AppLoader />;

  return null;
};

export default withAuthRequired(Dashboard, {
  roles: [USER_ROLES.talentManager],
});
